export enum ROUTES {
    START = 'Start',
    ORDER_DETAILS = 'OrderDetails',
    ORDER_PAYMENT_STATUS = 'OrderPaymentStatus',
    ORDER_SHIPPING_STATUS = 'OrderShippingStatus',
    TERMS_OF_USE = 'TermsOfUse',
    POLICY_COOKIES = 'PolicyCookies',
    POLICY_PRIVACY = 'PolicyPrivacy',
}
